<h2 mat-dialog-title>Select a User</h2>
<mat-dialog-content>
  <p>Multiple users were found. Please select one:</p>
  <mat-list>
    <mat-list-item *ngFor="let user of data.users" (click)="selectUser(user)">
      <div>
        <strong>{{ user.displayName }}</strong> ({{ user.mail }})
      </div>
    </mat-list-item>
  </mat-list>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="cancel()">Cancel</button>
</mat-dialog-actions>